import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToasterComponent } from '@shared/components/toaster/toaster.component';
import { ToasterListComponent } from '@shared/components/toaster/components/toaster-list/toaster-list.component';

@NgModule({
  imports: [CommonModule, ToasterComponent, ToasterListComponent],
  exports: [ToasterComponent],
})
export class ToasterModule {}
